import { CognitoUserPool } from "amazon-cognito-identity-js";

const poolData ={
    UserPoolId: "us-east-1_sc8gE0uZf",
    ClientId: "440gjaaubmcsk94rcge3suug7l"
}
export default new CognitoUserPool(poolData);